/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '@/application';
import { SignInPageService } from '../../../services';
import toast from 'react-hot-toast';

const MODULE_NAME = 'signIN.machines.states.signInUser';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.SignInPageService') as SignInPageService;
};

export const getEmailDetails = async (context: any, event: any) => {
  const currentState = 'GET_EMAIL_DETAILS';
  const method = 'getEmailDetails';

  return new Promise(async (resolve, reject) => {
    try {
      const srv = getSrv();
      console.log(`event?.payload`, event);
      const content = await srv.getEmailDetails(event);
      if (content) {
        return resolve({
          key: 'GET_EMAIL_DETAILS_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = content?.error;
        toast.error(msg);
        return reject({
          key: 'GET_EMAIL_DETAILS_FAILURE',
          value: content,
        });
      }
    } catch (err: any) {
      toast.error(err?.message);
      return reject({
        key: 'GET_EMAIL_DETAILS_FAILURE',
        value: 'Something went wrong please try again!',
      });
    }
  });
};
